<button mat-button (click)="toogleFiltro()" [style.background]="configuracao.cor"
    [class.inactive]="!configuracao.ativo">
    <span>{{ configuracao.nome }}</span>
    <span class="badge">{{ configuracao.quantidade }}</span>
</button>